
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "viewBox": "0 0 64 64",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "title"
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "School"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M60,59H57V36h3a1,1,0,0,0,.83-.44,1,1,0,0,0,.1-.93l-6-15A1,1,0,0,0,54,19H36a.7.7,0,0,0-.14,0L33,16.42V14h9a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H32a1,1,0,0,0-1,1v9.42L28.14,19A.7.7,0,0,0,28,19H10a1,1,0,0,0-.93.63l-6,15a1,1,0,0,0,.1.93A1,1,0,0,0,4,36H7V59H4a1,1,0,0,0,0,2H60a1,1,0,0,0,0-2ZM53.32,21l5.2,13H43V26a1.42,1.42,0,0,0,0-.22.75.75,0,0,0,0-.16,1.48,1.48,0,0,0-.08-.13,1.56,1.56,0,0,0-.14-.19l0,0L38,21ZM33,8h8v4H33ZM10.68,21H26l-4.66,4.26,0,0a1.18,1.18,0,0,0-.13.18,1.1,1.1,0,0,0-.09.14.66.66,0,0,0,0,.15A1.89,1.89,0,0,0,21,26v8H5.48ZM9,36H21V59H9ZM28,59V45h8V59Zm10,0V44a1,1,0,0,0-1-1H27a1,1,0,0,0-1,1V59H23V26.44l9-8.23,9,8.23V59Zm5,0V36H55V59Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M17,44H13a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V45A1,1,0,0,0,17,44Zm-1,4H14V46h2Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M51,44H47a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V45A1,1,0,0,0,51,44Zm-1,4H48V46h2Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M32,28a4,4,0,1,0,4,4A4,4,0,0,0,32,28Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,32,34Z"
          }
        }
      ]
    }
  ]
})
    }
  